// 星座数据
export const zodiacData = {
  1: {
    name: "白羊座",
    traits: ["热情直接", "占有欲强", "嫉妒心重", "控制欲明显"],
    self: "白羊座的你在恋爱中充满激情和活力，爱得直接而热烈。你会毫不掩饰地表达爱意，也希望对方给予同样热情的回应。你天生好胜，占有欲强，容易因伴侣与他人的互动而吃醋。你需要伴侣的专一和忠诚，但有时你的直率可能让对方感到压力。",
    partner: "白羊座的Ta在恋爱中充满激情和活力，爱得直接而热烈。Ta会毫不掩饰地向你表达爱意，也希望你给予同样热情的回应。Ta天生好胜，占有欲强，容易因你与他人的互动而吃醋。Ta需要你的专一和忠诚，但有时Ta的直率可能让你感到压力。",
    tips: {
      self: "学会控制冲动，给对方一些空间和时间。你的热情很珍贵，但不是每个人都能跟上你的节奏，耐心会让你的爱更长久。",
      partner: "欣赏Ta的热情，但也要温和地表达你对空间的需求。Ta的占有源于深爱，用稳定的行为给Ta安全感，同时帮助Ta理解信任的重要性。"
    }
  },
  2: {
    name: "金牛座",
    traits: ["占有欲极强", "缺乏安全感", "依赖性高", "害怕失去"],
    self: "金牛座的你在恋爱中稳重而专一，一旦认定就会全心投入。你的占有欲很强，非常重视安全感和稳定性。你希望伴侣能给予足够的陪伴和承诺，任何威胁到关系稳定的因素都会让你焦虑。你的爱深沉而持久，但也可能显得固执和不够灵活。",
    partner: "金牛座的Ta在恋爱中稳重而专一，一旦认定你就会全心投入。Ta的占有欲很强，非常重视安全感和稳定性。Ta希望你能给予足够的陪伴和承诺，任何威胁到你们关系稳定的因素都会让Ta焦虑。Ta的爱深沉而持久，但也可能显得固执和不够灵活。",
    tips: {
      self: "试着放松一些，不要把所有安全感都寄托在伴侣身上。培养自己的兴趣和生活，这样你的爱会更自由。",
      partner: "给Ta充分的安全感，保持行为的稳定性和可预测性。耐心沟通，帮助Ta理解适度的独立空间并不会威胁你们的关系。"
    }
  },
  3: {
    name: "双子座",
    traits: ["自由洒脱", "占有欲低", "不喜束缚", "独立性强"],
    self: "双子座的你在恋爱中灵活多变，享受新鲜感和自由。你的占有欲不强，更重视精神上的交流和默契。你给予伴侣很大的自由空间，也希望对方同样尊重你的独立性。你可能会被误解为不够专一，但其实你只是需要更多的个人空间和变化。",
    partner: "双子座的Ta在恋爱中灵活多变，享受新鲜感和自由。Ta的占有欲不强，更重视精神上的交流和默契。Ta给予你很大的自由空间，也希望你同样尊重Ta的独立性。Ta可能会被误解为不够专一，但其实Ta只是需要更多的个人空间和变化。",
    tips: {
      self: "记得偶尔表达你的在乎和重视，让对方知道自由不等于冷漠。稳定的情感表达会让你的伴侣更有安全感。",
      partner: "尊重Ta对自由和新鲜感的需求，用有趣的对话和活动保持关系的活力。不要试图控制Ta，信任和空间会让你们走得更远。"
    }
  },
  4: {
    name: "巨蟹座",
    traits: ["极度缺乏安全感", "情感依赖重", "占有欲强", "敏感多疑"],
    self: "巨蟹座的你在恋爱中极其敏感和缺乏安全感，情感依赖性很强。你渴望被爱和被需要，占有欲强，容易因小事而多想。你会把伴侣视为情感的港湾，需要频繁的确认和陪伴。你的爱细腻而温柔，但过度的粘人可能让对方喘不过气。",
    partner: "巨蟹座的Ta在恋爱中极其敏感和缺乏安全感，情感依赖性很强。Ta渴望被你爱和被需要，占有欲强，容易因小事而多想。Ta会把你视为情感的港湾，需要频繁的确认和陪伴。Ta的爱细腻而温柔，但过度的粘人可能让你喘不过气。",
    tips: {
      self: "学会建立内在的安全感，不要把所有情感寄托在伴侣身上。培养自己的兴趣和朋友圈，独立会让你更有魅力。",
      partner: "给Ta足够的关爱和确认，经常向Ta表达你的爱意。理解Ta的敏感，但也要温和地帮助Ta建立边界，让Ta知道你需要一些个人空间。"
    }
  },
  5: {
    name: "狮子座",
    traits: ["占有欲强", "控制欲明显", "嫉妒心重", "自尊心强"],
    self: "狮子座的你在恋爱中自信而热情，占有欲强，希望成为伴侣眼中唯一的焦点。你慷慨大方，愿意为爱人付出一切，但也期待同样的重视和崇拜。你的自尊心很强，嫉妒心重，不能容忍伴侣对你的忽视或背叛。你需要被欣赏和赞美。",
    partner: "狮子座的Ta在恋爱中自信而热情，占有欲强，希望成为你眼中唯一的焦点。Ta慷慨大方，愿意为你付出一切，但也期待你的重视和崇拜。Ta的自尊心很强，嫉妒心重，不能容忍你的忽视或背叛。Ta需要被你欣赏和赞美。",
    tips: {
      self: "学会分享注意力，不要总是需要成为中心。真正的自信来自内心，而非伴侣的崇拜。给对方一些主导权会让关系更平衡。",
      partner: "多赞美Ta，让Ta感受到你的欣赏和重视。但也要温和地设立边界，让Ta知道你有自己的生活和朋友圈。平衡Ta的需要和你的空间。"
    }
  },
  6: {
    name: "处女座",
    traits: ["理性控制", "细节关注", "焦虑倾向", "完美主义"],
    self: "处女座的你在恋爱中理性而谨慎，占有欲适中但焦虑感强。你注重细节，对关系有很高的标准和期待。你可能会过度分析伴侣的行为，担心关系出现问题。你的爱实际而细腻，但有时过于挑剔和完美主义。",
    partner: "处女座的Ta在恋爱中理性而谨慎，占有欲适中但焦虑感强。Ta注重细节，对关系有很高的标准和期待。Ta可能会过度分析你的行为，担心你们的关系出现问题。Ta的爱实际而细腻，但有时过于挑剔和完美主义。",
    tips: {
      self: "学会接受不完美，不要让焦虑毁了美好的关系。信任你的伴侣，不是每个细节都需要完美。放松一些，享受爱情的美好。",
      partner: "理解Ta的焦虑，给予Ta稳定和确认。不要过于在意Ta的挑剔，这是Ta表达关心的方式。帮助Ta放松，让Ta知道关系不需要完美。"
    }
  },
  7: {
    name: "天秤座",
    traits: ["平衡和谐", "占有欲适中", "理性温和", "重视公平"],
    self: "天秤座的你在恋爱中追求平衡和和谐，占有欲适中。你重视公平和相互尊重，希望关系中双方都能保持独立又亲密。你不喜欢冲突和控制，更倾向于通过沟通解决问题。你的爱优雅而理性，但有时会显得犹豫不决。",
    partner: "天秤座的Ta在恋爱中追求平衡和和谐，占有欲适中。Ta重视公平和相互尊重，希望你们的关系中双方都能保持独立又亲密。Ta不喜欢冲突和控制，更倾向于通过沟通解决问题。Ta的爱优雅而理性，但有时会显得犹豫不决。",
    tips: {
      self: "学会果断，不要总是在权衡利弊中错过表达爱意的机会。有时候感性比理性更重要，勇敢地表达你的感受。",
      partner: "珍惜Ta的成熟和平衡，这是很健康的恋爱模式。给Ta一些时间做决定，不要逼迫Ta。公平对待Ta，Ta会给你同样的尊重。"
    }
  },
  8: {
    name: "天蝎座",
    traits: ["占有欲极强", "嫉妒心爆表", "控制欲强", "深情执着"],
    self: "天蝎座的你在恋爱中强烈而深沉，占有欲极强。你爱得深刻而专一，一旦爱上就会全身心投入，也期待对方百分百的忠诚。你的嫉妒心很重，控制欲强，难以容忍任何威胁到关系的因素。你的爱炽热如火，但也可能让对方感到窒息。",
    partner: "天蝎座的Ta在恋爱中强烈而深沉，占有欲极强。Ta爱得深刻而专一，一旦爱上你就会全身心投入，也期待你百分百的忠诚。Ta的嫉妒心很重，控制欲强，难以容忍任何威胁到你们关系的因素。Ta的爱炽热如火，但也可能让你感到窒息。",
    tips: {
      self: "学会信任，不要让嫉妒和控制毁了珍贵的关系。你的深情很美，但要给对方呼吸的空间。尝试用沟通代替猜疑。",
      partner: "给Ta充分的安全感和忠诚，避免引发Ta的嫉妒。但也要温和而坚定地设立边界，让Ta知道过度的控制会伤害关系。寻求专业帮助如果需要。"
    }
  },
  9: {
    name: "射手座",
    traits: ["热爱自由", "占有欲极低", "不喜束缚", "洒脱开放"],
    self: "射手座的你在恋爱中热爱自由，占有欲极低。你享受恋爱带来的快乐，但不喜欢被束缚和控制。你给予伴侣极大的自由，也希望对方同样尊重你的独立性。你乐观开朗，但可能会被认为不够投入或缺乏责任感。",
    partner: "射手座的Ta在恋爱中热爱自由，占有欲极低。Ta享受恋爱带来的快乐，但不喜欢被你束缚和控制。Ta给予你极大的自由，也希望你同样尊重Ta的独立性。Ta乐观开朗，但可能会被认为不够投入或缺乏责任感。",
    tips: {
      self: "记得让伴侣知道你的在乎，自由不等于不负责任。偶尔的承诺和确认会让对方更有安全感，稳定中也可以保持自由。",
      partner: "尊重Ta对自由的需求，不要试图束缚Ta。用冒险和新鲜感保持关系的活力。如果你需要更多的陪伴，坦诚地告诉Ta。"
    }
  },
  10: {
    name: "摩羯座",
    traits: ["理性务实", "隐藏占有欲", "责任感强", "内敛深沉"],
    self: "摩羯座的你在恋爱中务实而稳重，占有欲适中但责任感强。你对关系很认真，一旦确定就会长期投入。你不太擅长表达情感，但会用实际行动证明你的爱。你的占有欲隐藏在理性之下，需要时会表现出来。",
    partner: "摩羯座的Ta在恋爱中务实而稳重，占有欲适中但责任感强。Ta对你们的关系很认真，一旦确定就会长期投入。Ta不太擅长表达情感，但会用实际行动证明Ta的爱。Ta的占有欲隐藏在理性之下，需要时会表现出来。",
    tips: {
      self: "学会表达你的情感，不要总是用行动代替语言。伴侣需要听到你的爱意，不只是看到你的付出。放松一些，享受当下的快乐。",
      partner: "理解Ta的沉默和务实，这是Ta表达爱的方式。给Ta时间打开心扉，不要急于求成。欣赏Ta的稳定和责任感，这很珍贵。"
    }
  },
  11: {
    name: "水瓶座",
    traits: ["独立自主", "占有欲很低", "理性冷静", "尊重空间"],
    self: "水瓶座的你在恋爱中独立而理性，占有欲很低。你重视精神层面的契合，给予伴侣极大的自由和尊重。你不喜欢传统的恋爱模式，更追求独特和平等的关系。你的冷静可能让对方觉得你不够热情，但这就是你的方式。",
    partner: "水瓶座的Ta在恋爱中独立而理性，占有欲很低。Ta重视精神层面的契合，给予你极大的自由和尊重。Ta不喜欢传统的恋爱模式，更追求独特和平等的关系。Ta的冷静可能让你觉得Ta不够热情，但这就是Ta的方式。",
    tips: {
      self: "记得表达你的在乎，不要让独立变成冷漠。偶尔的浪漫和情感流露会让对方更有被爱的感觉。",
      partner: "尊重Ta的独特性和对自由的需求，不要试图改变Ta。用理性的对话和共同的兴趣维系关系。如果你需要更多的情感表达，直接告诉Ta。"
    }
  },
  12: {
    name: "双鱼座",
    traits: ["浪漫多情", "情感依赖强", "缺乏安全感", "敏感脆弱"],
    self: "双鱼座的你在恋爱中浪漫而敏感，情感依赖性强。你渴望童话般的爱情，占有欲适中但不安全感很强。你会把伴侣理想化，容易因现实与幻想的差距而失落。你的爱细腻而梦幻，但有时过于脆弱和需要保护。",
    partner: "双鱼座的Ta在恋爱中浪漫而敏感，情感依赖性强。Ta渴望童话般的爱情，占有欲适中但不安全感很强。Ta会把你理想化，容易因现实与幻想的差距而失落。Ta的爱细腻而梦幻，但有时过于脆弱和需要保护。",
    tips: {
      self: "接受现实，不要活在幻想中。伴侣是真实的人，不是你理想中的完美形象。建立自我，不要完全依赖对方的爱来定义自己。",
      partner: "温柔对待Ta的敏感，但也要帮助Ta面对现实。给Ta浪漫和安全感，但也要让Ta知道你不是完美的，你们的关系需要双方的努力。"
    }
  }
}

